/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const offplanBehavior = useStore((state) => state.offplanBehavior);
  const setOffplanBehavior = useStore((state) => state.setOffplanBehavior);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.offplanBehavior.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={offplanBehavior}
          onChange={(value) => {
            setOffplanBehavior(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'offplan-behavior',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'eatWhatever'}>
            <span>🍔</span> {t('onboarding.offplanBehavior.options.eatWhatever')}
          </Option>
          <Option value={'estimateBest'}>
            <span>🧠</span> {t('onboarding.offplanBehavior.options.estimateBest')}
          </Option>
          <Option value={'feelFailed'}>
            <span>😅</span> {t('onboarding.offplanBehavior.options.feelFailed')}
          </Option>
          <Option value={'stayFlexible'}>
            <span>🧘‍♀️</span> {t('onboarding.offplanBehavior.options.stayFlexible')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
